import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ChatService } from 'src/app/services/chat.service';

@Injectable()
export class ChatViewEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    private service: ChatService) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.details()),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

  chatClosed$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestChatClosedAction),
    switchMap((action: any) => this.service.closeChat()),
    map((data: any) => {
      return ActionsList.ResponseChatClosedAction({ payload: data.data });
    })
  ));


  newClosed$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestNewChatAction),
    switchMap((action: any) => this.service.newChat()),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

  // isLoggedIn$ = createEffect(() => this.actions$.pipe(
  //   ofType(ActionsList.IsLoggedInAction),
  //   switchMap((action: any) => this.service.isLoggedIn()),
  //   map((data: any) => {
  //     return ActionsList.LoggedInAction({ payload: '' });
  //   })
  // ));
}
